import {
  LinkField,
  RichText,
  TextField,
} from '@sitecore-jss/sitecore-jss-react';
import React, { ReactElement } from 'react';
import BaseBtn from '../../@shared/BaseBtn';
import '../CardContent.scss';
import { trackWithGoogleTagManager } from '../../../utils/analytics';
const ContactContent = (props: {
  title: { value: string };
  icon?: { value: string };
  content: { value: string };
  formPlaceholder: { value: string };
  select: ReactElement;
  linkTitle: TextField;
  link: LinkField;
}) => {
  const track = () => {
    trackWithGoogleTagManager({
      event: 'event_contactus',
      eventCategory: 'contactus',
      eventAction: 'open_contactus',
      eventLabel: 'general_information',
    });
  };

  return (
    <section className={'CardContent__section_container'}>
      <div className={'CardContent__title_section'}>
        <h3>{props?.title?.value}</h3>
        <span
          className={`icon ${
            props.icon && props.icon?.value
          } CardContent__icon`}
        />
      </div>
      <RichText className={'CardContent__description'} field={props?.content} />
      <p className={'CardContent__form_placeholder'}>
        {props.formPlaceholder?.value}
      </p>
      {props?.select}
      <div className={'CardContent__button_div'}>
        <p className={'CardContent__form_placeholder'}>
          {props.linkTitle.value}
        </p>
        <BaseBtn
          isFullwidth={true}
          fields={{
            label: { value: props?.link.value.text },
            link: props?.link,
          }}
          action={track}
        />
      </div>
    </section>
  );
};
export default ContactContent;
